<app-modal-wrapper (cancel)="onCancel()" (save)="onSave()" [options]="options" [isValid]="isDirty">
  <div class="user-settings-container">
    <kendo-tabstrip [tabPosition]="'left'">
      <kendo-tabstrip-tab *ngFor="let tab of settingsTabs" title="{{tab.title}}" [selected]="tab.selected">
        <ng-template kendoTabContent>
          <app-user-settings-tab-container #settingsComponent [item]="tab.component" (isDirtyChanged)="dirtyChanged($event)"></app-user-settings-tab-container>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </div>
</app-modal-wrapper>
